import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  baseUrl = environment.apiHost;
  authToken: string | null = '';

  constructor(private httpClient: HttpClient) {}

  //Display respective name for the retreived status i
  getStatusClass(statusName: string): string {
    switch (statusName) {
      case 'In progress':
        return 'in-progress';
      case 'Scheduled':
        return 'scheduled';
      case 'Cancelled':
        return 'cancelled';
      case 'Completed':
        return 'completed';
      case 'Warranty':
        return 'warranty';
      default:
        return '';
    }
  }

  //Attach Icons for Status
  getStatusIcon(statusName: string): string {
    if (!statusName) {
      return '/assets/images/icons-kpi-dashboard/default-icon.png'; // Default icon if status is not available
    }
    switch (statusName) {
      case 'In progress':
        return './../../../../assets/images/icons-kpi-dashboard/icons/in-progress-icon.png';
      case 'Scheduled':
        return './../../../../assets/images/icons-kpi-dashboard/icons/scheduled-icon.png';
      case 'Cancelled':
        return './../../../../assets/images/icons-kpi-dashboard/icons/cancelled-icon.png';
      case 'Completed':
        return './../../../../assets/images/icons-kpi-dashboard/icons/completed-icon.png';
      case 'Warranty':
        return './../../../../assets/images/icons-kpi-dashboard/icons/warranty-icon.png';
      default:
        return './../../../../assets/images/icons/icons-kpi-dashboard/default-icon.png'; // Default icon for unknown status
    }
  }

  filterDates(d: Date | null): boolean {
    const today = new Date();
    if (d === null) return false;
    return d <= today;
  }

  public statusToAccountsMapping: Record<string, number> = {
    Open: 1,
    Imported: 2,
    'Insert Failed': 3,
    'Update Failed': 4,
    'Recently Changed': 5,
    // Add any other statusDesc values your data might have with their corresponding numbers
    // 'Cancelled': 0.5,
    // 'On Hold': 1.5,
  };

  public statusToInvoiceMapping: Record<string, number> = {
    Open: 10,
    Imported: 20,
    Error: 30,
    'Open Special': 11,
  };

  public monthNames: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  /**
   * Helper function to extract month name from a date string.
   * Uses `profileCreationDate` from your data.
   */
  public getMonthFromDate(dateString: string): string {
    const date = new Date(dateString);
    return this.monthNames[date.getMonth()];
  }
}
